import React from 'react';
import './Configuracao.css';
import { MdFolder, MdPeople } from 'react-icons/md';
import { RiRobot2Fill } from "react-icons/ri";
import { FaCogs } from "react-icons/fa";
// 1. Importe o 'Outlet' e 'useNavigate' para gerenciar as rotas
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const Configuracao = () => {
    // 2. Remova o estado que controlava o componente renderizado
    // const [selectedOption, setSelectedOption] = useState(null);

    // 3. Use o hook 'useNavigate' para controlar a navegação
    const navigate = useNavigate();
    const location = useLocation();

    // Função auxiliar para destacar o menu ativo
    const isActive = (path) => location.pathname.includes(path);

    // 4. A função 'renderSelectedComponent' não é mais necessária
    //    O <Outlet /> fará o trabalho dela.

    return (
        <div className="configuracao-container">
            <h2 className="configuracao-title">Painel de Configuração</h2>
            
            <div className="configuracao-buttons">
                {/* 5. Atualize os 'onClick' para navegar para as rotas filhas */}
                <p onClick={() => navigate('uploadlogo')} className={isActive('uploadlogo') ? 'active' : ''}>
                    <MdPeople size="24" /> Logo
                </p>
                <p onClick={() => navigate('usuarios')} className={isActive('usuarios') ? 'active' : ''}>
                    <MdPeople size="24" /> Usuários
                </p>
                <p onClick={() => navigate('temas')} className={isActive('temas') ? 'active' : ''}>
                    <MdFolder size="24" /> Temas
                </p>
                <p onClick={() => navigate('minicursos')} className={isActive('minicursos') ? 'active' : ''}>
                    <MdFolder size="24" /> Curso
                </p>
                <p onClick={() => navigate('bot')} className={isActive('bot') ? 'active' : ''}>
                    <RiRobot2Fill size="24" /> Bot e WhatsApp
                </p>
                <p onClick={() => navigate('administracao')} className={isActive('administracao') ? 'active' : ''}>
                    <FaCogs size="24" /> Administração
                </p>
            </div>

            <div className="configuracao-content">
                {/* 6. Use o <Outlet /> para renderizar o componente da rota filha */}
                <Outlet />
            </div>
        </div>
    );
};

export default Configuracao;
